package kz.dentalcrm.app.screens.menu

import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.network.LogoutEventBus
import kz.dentalcrm.app.domain.AuthRepository
import kz.dentalcrm.app.screens.menu.mvi.MenuViewEvent
import kz.dentalcrm.app.screens.menu.mvi.MenuViewSideEffect
import kz.dentalcrm.app.screens.menu.mvi.MenuViewState
import org.koin.core.component.inject

class MenuViewModel : BaseStateViewModel<MenuViewEvent, MenuViewState, MenuViewSideEffect>() {

    private val authRepository: AuthRepository by inject()

    override fun setInitialState() = MenuViewState()

    override fun handleEvents(event: MenuViewEvent) {
        when (event) {
            MenuViewEvent.LogOut -> logOut()
        }
    }

    private fun logOut() {
        setState { copy(isLoggingOut = true) }
        launch {
            authRepository.clearAllData()
            LogoutEventBus.emit()
        }
    }
}
